// extracted by mini-css-extract-plugin
export var collapsedSummary = "_q5-0";